import {
  PaneDirective,
  PanesDirective,
  SplitterComponent,
} from '@syncfusion/ej2-react-layouts';
import * as React from 'react';
import Team from './Team';
import Trades from './Trades';
import Assignments from './Assigments';
import ScheduleApp from '../../components/GlobalScheduler';
import MainGrafik from './Charts/MainGrafik';
import FilterContext from '../../context/FilterContext';
interface IProp {}
interface IState {
  renderKey: number;
}

class App extends React.Component<IProp, IState> {
  constructor(prop: IProp) {
    super(prop);
    this.state = {
      renderKey: 0,
    };
  }

  private resizeRaf: number | null = null;
  private triggerWindowResize = () => {
    if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
    this.resizeRaf = requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'));
    });
  };

  private handleOrgChange = () => {
    const { pathname, hash } = window.location;
    const fullPath = (pathname + hash).toLowerCase();
    const isTradePlannerModule = /(^|\/|#)tradeplanner(\/|\?|#|$)/i.test(fullPath);
    if (isTradePlannerModule) {
      this.setState(
        prev => ({ renderKey: prev.renderKey + 1 }),
        () => {
          this.triggerWindowResize();
        }
      );
    }
  };

  componentDidMount() {
    window.addEventListener('organizationChanged', this.handleOrgChange);
  }

  componentWillUnmount() {
    if (this.resizeRaf) cancelAnimationFrame(this.resizeRaf);
    window.removeEventListener('organizationChanged', this.handleOrgChange);
  }
  firstPaneContent = () => {
    return (
      <div>
        <div className='content'>
          <div className='Teams'>
            <Team key={`team-${this.state.renderKey}`} />
          </div>
        </div>
      </div>
    );
  };
  secondPaneContent = () => {
    return (
      <div
       /*  style={{
          height: '93%',
        }} */
      >
        <div
          className='contentMiddle'
          style={{
            height: 'calc(94vh - 20px)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'start',
            alignItems: 'center',
            overflow: 'hidden',
          }}
        >
          <div style={{ width: '100%', height: 'auto' }}>
            <MainGrafik key={`chart-${this.state.renderKey}`} />
          </div>
          <div
            style={{
              width: '100%',
              height: 'auto',
            }}
          >
            <ScheduleApp key={`scheduler-${this.state.renderKey}`} />
          </div>
        </div>
      </div>
    );
  };
  TradesPaneContent = () => {
    return <Trades key={`trades-${this.state.renderKey}`} />;
  };
  AssignmentsPaneContent = () => {
    return <Assignments key={`assign-${this.state.renderKey}`} />;
  };

  thirdPaneContentSplitter = () => {
    return (
      <SplitterComponent
        id='expand-collapse-inner'
        key={`splitter-inner-${this.state.renderKey}`}
        className='splitter'
        orientation='Vertical'
        height='95vh'
        resizing={this.triggerWindowResize}
        resizeStop={this.triggerWindowResize}
      >
        <PanesDirective>
          <PaneDirective
            min='6%'
            size='35%'
            max='94%'
            content={this.TradesPaneContent}
          />
          <PaneDirective
            min='6%'
            size='60%'
            max='94%'
            content={this.AssignmentsPaneContent}
          />
        </PanesDirective>
      </SplitterComponent>
    );
  };
  render() {
    return (
      <FilterContext.Provider value={this.state}>
        <div
          key={`tp-app-${this.state.renderKey}`}
          className='App'
          id='SplitterInner'
          style={{ width: '100%', height: '100vh' }}
        >
          <SplitterComponent id='expand-collapse' className='splitter'
            key={`splitter-${this.state.renderKey}`}
            resizing={this.triggerWindowResize}
            resizeStop={this.triggerWindowResize}
          >
            <PanesDirective>
              <PaneDirective
                size='12.1%'
                max='15.1%'
                content={this.firstPaneContent}
                collapsible={false}
              />
              <PaneDirective size='71.9%' content={this.secondPaneContent} />
              <PaneDirective
                size='17%'
                max='17%'
                content={this.thirdPaneContentSplitter}
                collapsible={false}
              />
            </PanesDirective>
          </SplitterComponent>
        </div>
      </FilterContext.Provider>
    );
  }
}
export default App;
